import type { CaptureResult } from "posthog-js"

const REVIEW_PATH = /(\/review\/)[^/?#]+/g
const UUID_PATH =
  /\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}(?=\/|$)/gi

export function sanitizePostHogRoute(pathname: string): string {
  return pathname.replace(REVIEW_PATH, "$1:token").replace(UUID_PATH, "/:id")
}

function sanitizeValue(value: unknown): unknown {
  if (typeof value === "string") return value.replace(REVIEW_PATH, "$1:token")
  if (Array.isArray(value)) return value.map(sanitizeValue)
  if (value !== null && typeof value === "object") {
    return sanitizeProperties(value)
  }
  return value
}

function sanitizeProperties(properties: object): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(properties).map(([key, value]) => [
      key,
      sanitizeValue(value),
    ]),
  )
}

export function sanitizePostHogEvent(
  event: CaptureResult | null,
): CaptureResult | null {
  if (!event) return null
  const currentUrl = event.properties?.$current_url
  const reviewPageview =
    event.event === "$pageview" &&
    typeof currentUrl === "string" &&
    REVIEW_PATH.test(currentUrl)
  REVIEW_PATH.lastIndex = 0
  if (
    event.event === "$pageview" &&
    typeof event.properties?.tenant_id !== "string"
  ) {
    return null
  }
  if (reviewPageview && event.properties?.review_context_ready !== true) {
    return null
  }
  return {
    ...event,
    properties: sanitizeProperties(event.properties),
    ...(event.$set && { $set: sanitizeProperties(event.$set) }),
    ...(event.$set_once && { $set_once: sanitizeProperties(event.$set_once) }),
  }
}
